import { Directive, Injector, Optional } from '@angular/core';

import { APPLY_STYLES_TYPE, BaseComponent, IWidgetConfig, Parent, StylableComponent, provideAsWidgetRef, register, styler } from '@wm/components-base';

const WIDGET_CONFIG: IWidgetConfig = {
    widgetType: 'wm-dialogactions',
    hostClass: 'app-dialog-footer modal-footer'
};

@Directive({
    standalone: true,
    selector: 'div[wmDialogFooter]',
    providers: [
        provideAsWidgetRef(DialogFooterDirective)
    ],
    exportAs: 'wmDialogFooter',
})
export class DialogFooterDirective extends StylableComponent {
    static initializeProps = register('wm-dialogactions');

    constructor(inj: Injector, @Optional() viewParent: Parent) {
        super(inj, WIDGET_CONFIG, viewParent);
        styler(this.nativeElement, this, APPLY_STYLES_TYPE.CONTAINER);
    }
}
